export const HTTP_ERROR_MESSAGE = {
  400: '不正なリクエスト', // Bad Request
  401: '認証されていません', // Unauthorized
  403: 'アクセス禁止', // Forbidden
  404: '見つかりません', // Not Found
  405: '許可されていないメソッド', // Method Not Allowed
  500: '内部サーバーエラー', // Internal Server Error
  502: '不正なゲートウェイ', // Bad Gateway
  503: 'サービス利用不可', // Service Unavailable
  504: 'ゲートウェイタイムアウト', // Gateway Timeout
};

export const UNKNOWN_ERROR = '不明なエラーが発生しました。';

export const DROP_FILE_TITLE = 'ファイルをドラッグ＆ドロップするか\nファイルを選択してください。';

export const ORDER_STRING = {
  TOOLTIP_IMPORT: {
    STRING_1: '内示データをCSVファイルから一括で取り込むことができます。',
    STRING_2: 'ファイル名は 内示_yyyymm●●.csv の形式で名付ける必要があります。',
  },
  WARNING_PRODUCT_MASTER: '未登録の製品があります。「登録」もしくは「製品マスタ取込」をしてください。',
  STATUS: {
    OPEN: 'オープン',
    IN_PROGRESS: '進行中',
    CLOSE: 'クローズ',
  },
  FORM_ID: {
    OVERVIEW: 'order_overview',
    PRODUCT_MASTER: 'product_master',
    ESTIMATED_STOCK: 'estimated_stock',
  },
  SHIPPING_PLAN: {
    PLAN_SHIP_EXCESSED_LIMIT: 'すべての配送の合計数量が計画上限（total_plan）を超えることはできません。',
  },
  ERROR: {
    NOT_MATCHING_TOTAL_QUANTITY_WITH_SCHEDULED_QUANTITY: '合計数量がスケジュール数量と一致しません。',
  },
  WARNING: {
    CHANGE_ORDER_NUMBER: '手配数の変動がありました。『発注番号発行』ボタンを実行してください。',
  },
};

export const PRODUCTION_STRING = {
  FILE_NAME: {
    INVOICE: '送り状',
    DAILY_WORK_REPORT: '作業日報',
    SHIPPING: 'P包装納入依頼書',
  },
  KEY_CREATE: {
    INVOICE: 'invoice',
    DAILY_WORK_REPORT: 'daily_work_report',
    SHIPPING: 'shipping',
  },
  EXPORT: {
    DAILY_REPORT: '日計表_yyyymmdd.csv',
    MANUFACTURING_SHIPPING: '製造管理_yyyymmdd.csv',
    INVENTORY_FORM: '棚卸表_yyyymmdd.csv',
    EXPORT_DATA_SUCCESS: 'データの出力が完了しました。',
  },
  ERROR: {
    INVALID_FILE: '指定された正しいファイルをアップロードしてください。',
    INVALID_CONTENT: '取込が失敗しました。ファイルを修正の上、再取込してください。',
    NOT_DATA: 'データがありません。',
    INVALID_HEADER: 'ファイルのヘッダー内容が正しくありません。',
    IMPORT_DAILY_REPORT: {
      SHORTAGE_QUANTITY_NOT_MAPPING: 'ロス数は無効です。ロス数は「本日製函投入数 - 本日製函出来上数」の差でなければなりません。',
      FINISHED_QUANTITY_GREATER_THAN_SEMI_FINISHED_QUANTITY: '本日製函出来上数は本日製函投入数より大きくすることはできません。',
      EXCEEDING_WORK_IN_PROCESS: '本日製函投入数は、発注番号の仕掛数を超えてはいけません。',
    },

    IMPORT_SHIPPING: {
      INSUFFICIENT_INVENTORY: '「在庫」が不足しているため、納品処理を実行できません。',
      EXCEEDING_DELIVERY_QUANTITY: '「納品日」が不適切なため、納品処理を実行できません。',
      NOT_PLANS_SHIPPING: '納品予定がありません。',
      PRODUCT_ORDER_NOT_FOUND: '商品の注文が見つかりません。',
    },
    SOMETHING_WENT_WRONG: '取込が失敗しました。もう一度お試しください。',
  },
};

export const NITTOKU_CODE_NOT_FORMAT = '日特コードのフォーマットが正しくありません。';
export const PRODUCT_MASTER_STRING = {
  DATA_NOT_MAPPING: '入力されたデータは画面上の新製品と一致しません。',
};

export const APP_TABLE = {
  EMPTY_DATA: '表示するデータはありません。',
};

export const TAB_STATE_NUMBER = {
  ONE: 1,
  TWO: 2,
};

export const PRODUCT_STRING = {
  MODAL_CONFIRM_MESSENGER_EDIT: '編集内容を保存されていない可能性があります。このまま編集画面を離れますか。',
  MODAL_CONFIRM_MESSENGER_CREATE: '登録内容を保存されていない可能性があります。このまま登録画面を離れますか。',
  OVERWRITE_REAL_INVENTORY: '在庫数の編集に成功しました。',
  OVERWRITE_WORK_IN_PROGRESS: '仕掛数の編集に成功しました。',
};

export const FILE_IMPORT_INVENTORY = {
  ACTUAL_INVENTORY: '棚卸在庫数',
  WORK_IN_PROGRESS: '棚卸仕掛数',
};
